/*
 * @Author: xiaokun
 * @Date: 2020-04-13 11:36:52
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-04 14:01:42
 * @Description: 未审批列表 配置
 */
import ListTableAction from './list-table-action'

export function unExamineList (val) {
  let list = {}
  list = {
    type: 'Table', // or Image
    columns: [{
      prop: 'employeeName',
      label: '姓名',
      minWidth: '150',
      showOverflowTooltip: true
    }, {
      prop: 'depName',
      label: '部门',
      minWidth: '150',
      showOverflowTooltip: true
    }, {
      prop: 'taskName',
      label: '关联任务',
      minWidth: '150'
    }, {
      prop: 'duration',
      label: '答卷时长',
      minWidth: '150'
    }, {
      prop: 'participationTime',
      label: '交卷时间',
      minWidth: '150'
    }, {
      prop: 'action',
      label: '操作',
      minWidth: '150',
      // 自定义组件
      component: ListTableAction
    }]
  }
  if (val === 'learnTask') {
    list = {
      type: 'Table', // or Image
      columns: [{
        prop: 'employeeName',
        label: '姓名',
        minWidth: '150'
      }, {
        prop: 'depName',
        label: '部门',
        minWidth: '150'
      }, {
        prop: 'duration',
        label: '答卷时长',
        minWidth: '150'
      }, {
        prop: 'participationTime',
        label: '交卷时间',
        minWidth: '150'
      }, {
        prop: 'action',
        label: '操作',
        minWidth: '150',
        // 自定义组件
        component: ListTableAction
      }]
    }
  }
  return list
}
